<template>
    <div class="el" style="padding-left:20px;padding-right:20px;">
        <el-form :model="formUserInfo" ref="formUserInfo" :rules="rules">
            <el-row>
                <div v-for="(item, k) in formUserInfo.userExtends" :key="item.sId">
                    <el-col :span="item.sExtendType === 'checkboxgroup' ? 24 : 8">
                        <el-form-item
                            :key="item.sId"
                            :label-width="item.sExtendType === 'checkboxgroup' ? '10%' : formLabelWidth"
                            :label="item.sName"
                            :prop="'userExtends.' + k + '.optionValue'"
                            :rules="getCheckRule(item)"
                        >
                            <td-input v-if="item.sExtendType === 'input'" v-model="item.optionValue" :type="item.sParam"></td-input>
                            <div v-if="item.sExtendType === 'combobox'">
                                <td-select v-model="item.optionValue" :options="item.sParam.split(',')" :hasBasicTypes="true"></td-select>
                            </div>
                            <div v-if="item.sExtendType === 'date'">
                                <el-date-picker type="date" :placeholder="$t('common.SELECT_DATE')" v-model="item.optionValue"></el-date-picker>
                            </div>
                            <div v-if="item.sExtendType === 'radio'">
                                <el-radio-group v-model="item.optionValue">
                                    <el-radio v-for="(op, i) in item.sParam.split(',')" :key="i" :label="op" :value="op"></el-radio>
                                </el-radio-group>
                            </div>
                            <div v-if="item.sExtendType === 'checkbox'">
                                <el-checkbox v-model="item.optionValue" :label="item.sParam">{{ item.sParam }}</el-checkbox>
                            </div>
                            <div v-if="item.sExtendType === 'radiogroup'">
                                <td-radio :hasBasicTypes="true" size="small" :options="item.sParam.split(',')" v-model="item.optionValue" :hasBasicTypes="true"></td-radio>
                            </div>
                        </el-form-item>
                    </el-col>
                </div>
            </el-row>
        </el-form>
        <el-row>
            <div style="text-align: center;">
                <td-button type="primary" @click="submitForm('formUserInfo')" :loading="loading">{{ $t('common.SAVE') }}</td-button>
                <td-button type="button" @click="userDialogClose()">{{ $t('common.CANCEL') }}</td-button>
            </div>
        </el-row>
    </div>
</template>
<script>
import resourceApi from '../assets/api.js';
export default {
    props: {
        //系统标识
        sysFlg: {
            type: String,
            default: function() {
                return 'PG';
            }
        },
        //编辑用户参数
        editItem: {
            type: Object,
            default: function() {
                return {};
            }
        },
        isAddData: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        extendList: {
            type: Array,
            default: function() {
                return [];
            }
        },
        moduleId: {
            type: String,
            default: function() {
                return '';
            }
        },
        loading: {
            type: Boolean,
            default: function() {
                return false;
            }
        }
    },
    components: {},
    created() {
        //获取扩展信息
        this.formUserInfo.userExtends = this.extendList;
        //扩展信息里的正则
        for (let index = 0; index < this.formUserInfo.userExtends.length; index++) {
            const element = this.formUserInfo.userExtends[index];
            this.rules[element.sId] = [];
            if (element.isCheckNull === 1) {
                this.rules[element.sId].push({
                    required: true,
                    validator: this.validateExtendName,
                    trigger: 'blur'
                });
            } else {
                this.rules[element.sId].push({
                    validator: this.validateExtendName,
                    trigger: 'blur'
                });
            }
        }
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            let content = {
                sId: this.editItem.userId,
                sysFlg: this.sysFlg
            };
            resourceApi.getUserExtendsValues(JSON.stringify(content), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('user/getUserExtendsValues', response.data.statusMessage);
                    return;
                }
                let values = response.data.content;
                if (values.length === 0) {
                    return;
                }
                this.formUserInfo.userExtends.forEach(extend => {
                    values.forEach(val => {
                        if (val.sExtendId == extend.sId) {
                            if (extend.sExtendType === 'checkboxgroup') {
                                let arr = val.sValue.split('|');
                                extend.optionValue = arr;
                            } else if (extend.sExtendType === 'checkbox') {
                                let arr = val.sValue === 'true';
                                extend.optionValue = arr;
                            } else {
                                extend.optionValue = val.sValue;
                            }
                        }
                    });
                });
            });
        } else {
            this.formUserInfo.userExtends.forEach(extend => {
                if (extend.sExtendType === 'checkboxgroup') {
                    extend.optionValue = [];
                }
            });
        }
    },
    // 定义变量
    data() {
        return {
            formLabelWidth: '30%',
            // User表单信息
            formUserInfo: {
                userExtends: []
            },
            rules: {}
        };
    },
    // 定义并实现方法体
    methods: {
        getCheckRule(item) {
            var rules = [];
            if (item.iRequired == 1) {
                let requireRules = {
                    required: true,
                    message: this.$t('error.ERROR_INPUT'),
                    trigger: 'change'
                };
                rules.push(requireRules);
            }
            if (!this.$util.isEmpty(item.sCheckRule)) {
                let otherRules = { pattern: item.sCheckRule, message: item.sCheckTips };
                rules.push(otherRules);
            }
            return rules;
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$emit('submitForm', this.moduleId);
                }
            });
        },
        getFormData() {
            let extendInfo = {};
            this.$refs['formUserInfo'].validate(valid => {
                if (valid) {
                    let extendIds = [];
                    let extendVals = [];
                    this.formUserInfo.userExtends.forEach(val => {
                        extendIds.push(val.sId);
                        if (Array.isArray(val.optionValue)) {
                            extendVals.push(val.optionValue.join('|'));
                        } else {
                            extendVals.push(val.optionValue);
                        }
                    });
                    extendInfo.extendIds = extendIds;
                    extendInfo.extendVals = extendVals;
                    extendInfo.isError = false;
                } else {
                    extendInfo.isError = true;
                }
            });
            return extendInfo;
        },
        userDialogClose() {
            this.$emit('personalInfoClose');
        }
    }
};
</script>
<style scoped>
.userDialog >>> .el-dialog__body {
    padding-left: 20px !important;
    padding-right: 20px !important;
}
.el >>> .el-form .el-row:nth-child(1) .el-form-item {
    position: relative;
}
</style>
